import { Lesson } from '../../../../types';

const lesson: Lesson = {
  itemId: '2084275',
  title: 'Não será fácil',
  video: { platform: 'youtube', videoId: 'L0lD_IuKGEk' },
  article: ['Descrição da aula.'],
};
export default lesson;

